import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "common-title" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("基础信息")
], -1)
const _hoisted_2 = {
  key: 0,
  class: "common-title"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("资质材料")
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_preview_image = _resolveComponent("preview-image")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = $event)),
    title: "查看",
    width: "720px",
    class: "review-modal",
    footer: null,
    onCancel: _ctx.afterClose
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        model: _ctx.form,
        "label-col": { span: 4 },
        "wrapper-col": { span: 18 }
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_a_form_item, { label: "申请企业" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.form.corpName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "申请开通应用" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.form.appName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "申请时间" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.form.applyTime)), 1)
            ]),
            _: 1
          }),
          (_ctx.form.code === 'rengongwaihu' && _ctx.form.info)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _hoisted_3,
                _hoisted_4
              ]))
            : _createCommentVNode("", true),
          (_ctx.form.code === 'rengongwaihu' && _ctx.form.info)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode(_component_a_form_item, { label: "营业执照" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_preview_image, {
                      content: _ctx.form.info.license
                    }, null, 8, ["content"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "法人身份证" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_preview_image, {
                      content: _ctx.form.info.corpCard
                    }, null, 8, ["content"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "授权承诺书" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_preview_image, {
                      content: _ctx.form.info.authLetter
                    }, null, 8, ["content"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "客户来源证明" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_preview_image, {
                      content: _ctx.form.info.sourceProof
                    }, null, 8, ["content"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_a_form_item, { label: "联系电话" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.mobile), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "审批说明" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.desc || '-'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["visible", "onCancel"]))
}